<div id="main-content">

    <!-- Breadcrumb on the left -->
    <nav aria-label="breadcrumb" class="px-5 mb-0">
      <ol class="breadcrumb mb-0">
        <li class="breadcrumb-item"><a [routerLink]="['/home']">Workspaces</a></li>
        <li class="breadcrumb-item"><a [routerLink]="newUrl">Visual</a></li>
        <li class="breadcrumb-item active" aria-current="page">Dashboard</li>
      </ol>
    </nav>
  
    <!-- Centered text -->
    <div class="flex-grow-1 d-flex justify-content-center">
      <p class="fs-5 mb-4 text-center">Dashboard Information</p>
    </div>


  <div class="d-flex flex-column align-items-center">
  <div class="card" style="max-width: 50%; width: 100%;" *ngIf="dashboard; else noDashboard">
    <div class="card-body">
      <!-- Dashboard Details -->
      <ul class="list-group mb-3">
        <li class="list-group-item">
          <strong>Display Name:</strong> {{ dashboard.displayName }}
        </li>
        <li class="list-group-item">
          <strong>Is read only:</strong> {{ dashboard.isReadOnly }}
        </li>
      </ul>

      <!-- Button to go to the dashboard -->
      <div class="text-center">
        <a href="{{ dashboard.webUrl }}" class="btn btn-primary" target="_blank" rel="noopener">
          <i class="fas fa-external-link-alt"></i> Go to Dashboard <i class="bi bi-link"></i>
        </a>
      </div>
    </div>
  </div>
</div>
</div>

<!-- Fallback content if dashboard is not available -->
<ng-template #noDashboard>
  <div class="alert alert-warning text-center" style="max-width: 600px; margin: 0 auto;">
    No dashboard available.
  </div>
</ng-template>
